import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { RegraFiscal } from '../../model/regra_fiscal.model';

@Injectable()
export class RegraFiscalService extends EntityService<RegraFiscal> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'regra_fiscal',
      urlBackend: configService.backendURL
    });
  }
}
